import { useTheme } from '@automata/mui-theme';
import { BrushHandleRenderProps } from '@visx/brush/lib/BrushHandle';
import { Group } from '@visx/group';
import { CSSProperties, SVGProps } from 'react';

export type Props = BrushHandleRenderProps & {
  color: CSSProperties['fill'];
};

const BrushHandle = ({
  x,
  height,
  isBrushActive,
  width,
  className,
  color,
}: Props) => {
  const theme = useTheme();

  if (!isBrushActive) return null;

  const handleWidth = 13;
  const adjustedX = x - (handleWidth - width) / 2;

  const commonCircle: SVGProps<SVGCircleElement> = {
    fill: theme.palette.grey[300],
    r: 1.5,
    pointerEvents: 'none',
  };

  const isLeftHandle = className.includes('left');

  return (
    <Group
      left={adjustedX}
      top={0}
      data-testid={isLeftHandle ? 'brush-handle-left' : 'brush-handle-right'}
    >
      <rect
        className={className}
        width={Math.max(handleWidth, 0)}
        height={Math.max(height, 0)}
        fill={color}
        style={{ cursor: 'ew-resize' }}
        rx={3}
      />
      <Group left={handleWidth / 2}>
        <circle {...commonCircle} cx={-2.4} cy={height / 2 - 5} />
        <circle {...commonCircle} cx={-2.4} cy={height / 2} />
        <circle {...commonCircle} cx={-2.4} cy={height / 2 + 5} />
        <circle {...commonCircle} cx={2.4} cy={height / 2 - 5} />
        <circle {...commonCircle} cx={2.4} cy={height / 2} />
        <circle {...commonCircle} cx={2.4} cy={height / 2 + 5} />
      </Group>
    </Group>
  );
};

export default BrushHandle;
